import fb from './conf';

export const firebase = fb;
export const Auth = firebase.auth();
export const Ref  = firebase.database().ref( '/' );

export const FirebaseKey = () => Ref.push().key;

// According to Firebase Realtime Database: Keys must be non-empty strings and can't contain ".", "#", "$", "/", "[", or "]"
// TODO: encode all disallowed firebase characters
export const encodeKey = ( key ) => {
  if ( !key ) return '';

  const temp = replaceAll( key, '.', '_' );
  return `-${replaceAll( temp, '/', '&' )}`;
};
const replaceAll = ( str, target, replacer ) => str.split( target ).join( replacer );
